module.exports = "build/assets/periwinkleWave.7c886724.png";